import { useState, useEffect } from "react";
import { useChartPie } from "../../hooks";

export default function Module_HealthAnalysisManagement_Pie({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderPie } = useChartPie({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  useEffect(() => {
    if (!apiData) return;

    let formatData = [
      {
        是否異常: "人因工程",
        order: 99,
        人因工程: 6,
      },
      {
        是否異常: "過負荷(心理)",
        order: 99,
        "過負荷(心理)": 9,
      },
      {
        是否異常: "母性保護",
        order: 99,
        母性保護: 1,
      },
      {
        是否異常: "健康異常三級",
        order: 99,
        健康異常三級: 20,
      },
      {
        是否異常: "健康異常四級",
        order: 99,
        健康異常四級: 13,
      },
      // {
      //   是否異常: "新進同仁",
      //   order: 99,
      //   新進同仁: 0,
      // },
      // {
      //   是否異常: "個人健康問題",
      //   order: 99,
      //   個人健康問題: 0,
      // },
    ];

    setChartData({
      raw: exportData,
      format: formatData,
      export: null,
    });
  }, [apiData, exportData]);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderPie({
          moduleTitle,
          options: {
            moduleData: {
              ...moduleData,
              columns: [
                { key: "人因工程" },
                { key: "過負荷(心理)" },
                { key: "母性保護" },
                { key: "健康異常三級" },
                { key: "健康異常四級" },
              ],
            },
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
